'use client';
import { useSession } from '../../lib/session';
import { QualityWorkspace } from '../../components/desk/quality-workspace';
import { Desk, Banner } from '../../components/desk';
export default function QualityPage() {
  const { hasRole } = useSession();
  return ['PROFILE_CASE_HANDLER', 'PROFILE_CASE_REVIEWER', 'ORGANIZATION_ADMIN', 'GRASSROOTS_INFO_COORDINATOR'].some(hasRole) ? <QualityWorkspace /> : <Desk><Banner tone="neutral">当前职责不包含数据质量队列，请核对我的授权。</Banner></Desk>;
}
